import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded in EAKC-MVP: poll-missions.ts guards, finalize-step.ts retry
// cap, migration 192, and the 2026-05-17 OpenRouter cost-incident memory.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "One automated task quietly burned $55 of API credit in five days. My own dashboard never saw it." },
];

export const INCIDENT: ScriptLine[] = [
  { scene: "incident", fromSec: 0.4, holdSec: 6, caption: "OpenRouter billed $55. My cost dashboard showed $1.80. Both were 'right'." },
  { scene: "incident", fromSec: 6.8, holdSec: 5.5, caption: "Cost was only ever written on a SUCCESSFUL run, in completeAgentRun." },
  { scene: "incident", fromSec: 12.6, holdSec: 5, caption: "So the runs that cost the most — the ones that loop and fail — spent invisibly." },
];

export const WHY: ScriptLine[] = [
  { scene: "why", fromSec: 0.4, holdSec: 6, caption: "A recurring mission had a daily schedule but its cron string was NULL." },
  { scene: "why", fromSec: 6.8, holdSec: 5.5, caption: "Its send-email step failed every cycle, so it never finished — and never rescheduled cleanly." },
  { scene: "why", fromSec: 12.6, holdSec: 5.5, caption: "It refired roughly 1,190 times in 7 days, each cycle re-running a ~1M-token plan." },
];

export const ROOTCAUSE: ScriptLine[] = [
  { scene: "rootcause", fromSec: 0.4, holdSec: 6, caption: "I hit Pause. Nothing happened. That was the real bug." },
  { scene: "rootcause", fromSec: 6.8, holdSec: 6.5, caption: "pollMissions selected work by state only — it ignored the 'paused' status entirely." },
  { scene: "rootcause", fromSec: 13.6, holdSec: 4, caption: "Pause set status='paused'. The poller never read it." },
];

export const GUARDS: ScriptLine[] = [
  { scene: "guards", fromSec: 0.4, holdSec: 5.5, caption: "Autonomy without guardrails is just an expensive infinite loop. So I added three." },
  { scene: "guards", fromSec: 6.2, holdSec: 5.5, caption: "Guard one: skip any mission an operator paused. Run-Now still overrides it." },
  { scene: "guards", fromSec: 12, holdSec: 5.5, caption: "Guard two: drop recurring missions with a NULL cron — they can never reschedule, only refire." },
  { scene: "guards", fromSec: 17.8, holdSec: 5.2, caption: "Guard three: a retry cap. Three failures in a row drives the mission to a terminal failed state." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6.5, caption: "The poller now filters out paused and cron-NULL rows BEFORE the limit slice." },
  { scene: "code", fromSec: 7.4, holdSec: 6.5, caption: "One exemption: a mission already 'executing' is allowed to finish — with no cron it ends at 'done', it can't loop." },
  { scene: "code", fromSec: 14.5, holdSec: 6.5, caption: "And the retry cap is pure and deterministic: count + 1, capped at three. Migration 192 stores the counter." },
];

export const METER: ScriptLine[] = [
  { scene: "meter", fromSec: 0.4, holdSec: 6.5, caption: "The deeper lesson: never hang your cost meter off the success path." },
  { scene: "meter", fromSec: 7.2, holdSec: 6, caption: "The most expensive pattern — loop, fail, retry — never reaches 'complete'. So it never gets metered." },
  { scene: "meter", fromSec: 13.6, holdSec: 4.5, caption: "The meter has to wrap the outbound request itself." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.5, caption: "Give an agent a schedule and a credit card, and the Pause button has to actually work." },
  { scene: "outro", fromSec: 6.2, holdSec: 4.5, caption: "Next: how my AI writes its own skills after every chat." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
